<template>
  <header class="header">
    <nav class="header__navigation">
      <router-link to="/" tag="strong" class="header__navigation__logo">
        <img
          src="@/assets/logo.svg"
          alt="Logo"
          class="header__navigation__logo__icon"
        />
        <span class="header__navigation__logo__text">ConfCloud</span>
      </router-link>
      <!--<router-link to="/" class="header__navigation__link">So funktioniert's</router-link>
              <router-link to="/preise" class="header__navigation__link">Preise</router-link>
              <router-link to="/hilfe" class="header__navigation__link">Hilfe</router-link>-->
      <router-link
        to="/konto"
        class="header__navigation__link"
        v-if="isAuthenticated"
      >
        Konto
      </router-link>
      <router-link to="/login" class="header__navigation__link" v-else
        >Anmelden
      </router-link>
    </nav>
  </header>
</template>

<script>
export default {
  name: "Header",
  computed: {
    isAuthenticated: function() {
      return !!this.$store.state.user;
      //return localStorage.getItem("jwt") && localStorage.getItem("jwt") !== "";
    }
  }
};
</script>

<style scoped lang="scss">
.header {
  &__navigation {
    height: $headerHeight;
    padding: $headerVPadding 0;
    margin-bottom: $headerMarginBottom;

    box-shadow: 0 2px 2px -2px silver;

    display: flex;
    align-items: center;

    @include container;

    &__logo {
      display: flex;
      align-items: center;
      margin-right: auto;

      &__text {
        color: $primary;
        font-size: 1.25rem;
        letter-spacing: 0.15ch;
        margin-top: 0.5ch;
      }

      &__icon {
        height: 1.75rem;
        margin-right: 0.5rem;
      }

      &:hover,
      &:focus {
        color: $text;
      }
    }

    &__link {
      text-decoration: none;
      margin-left: 1rem;
      color: $text;

      &:hover,
      &:focus {
        color: $primary;
      }
    }

    @media (max-width: 767px) {
      margin-bottom: 0.5rem;
    }
  }
}
</style>
